app.service('config', ['constants', '$http',
    function (constants, $http) {

        function load() {
            console.log('loading config from remote ...');
            var self = this;

            function mergeConfig(response) {
                var remoteConfig = response.data;
                Object.keys(remoteConfig).forEach(function (item) {
                    if (self.hasOwnProperty(item) && typeof self[item] !== 'function') {
                        self[item] = remoteConfig[item];
                    }
                });
                log('config is loaded successfully');
            }

            var httpConfig = {
                method: 'GET',
                url: localConfig.configPath + 'config.json?' + Date.now(),
                timeout: 10000
            };

            return $http(httpConfig).then(mergeConfig);
        }

        var localConfig = {
            load: load,
            socket: {
                serverAddress: 'wss://trademarkets.pandats-client.io',
                path: '/socket.io',
                autoConnect: false,
                connectTimeout: 5000,
                reconnection: true,
                transports: ["websocket"],
                reconnect: true,
                reconnectionDelay: 5000,
                reconnectionLimit: 5000,
                maxReconnectionAttempts: 1000
            },
            traderName: "TradeMarkets",
            defaultCurrencySymbols: constants.currencySymbols.USD,
            languages: [
                {
                    id: 'en',
                    name: 'English'
                },
                {
                    id: 'de',
                    name: 'Deutsch'
                }
            ],
            autoLogin: false,
            defaultLanguage: "en",
            languagesPriority: ['en'],
            languageChooseOption: true,
            localizationPath: "locales/",
            localizationLoadTimeout: 10000,
            requestTimeout: 25000,
            currencyList: [],
            validations: {
                asset: {
                    "OutputName": {presence: {allowEmpty: false}},
                    "IsTradeable": {
                        presence: {allowEmpty: false},
                        numericality: {greaterThanOrEqualTo: 0, lessThanOrEqualTo: 2}
                    },
                    "IsShow": {
                        presence: {allowEmpty: false}
                    },
                    "Digits": {
                        presence: {allowEmpty: false},
                        numericality: {greaterThanOrEqualTo: 0, lessThanOrEqualTo: 10}
                    },
                    "Type": {presence: {allowEmpty: false}, numericality: true},
                    "Description": {presence: {allowEmpty: true}},
                    "ContractSize": {presence: {allowEmpty: false}, numericality: true},
                    "ProfitMode": {presence: {allowEmpty: false}, numericality: true},
                    "MarginMode": {presence: {allowEmpty: false}, numericality: true},
                    "Spread": {presence: {allowEmpty: false}, numericality: true},
                    "Category": {presence: {allowEmpty: true}},
                    "Currency": {presence: {allowEmpty: false}},
                    "Markup": {presence: {allowEmpty: false}, numericality: true},
                    "Percentage": {presence: {allowEmpty: false}, numericality: true},
                    "InitialMargin": {presence: {allowEmpty: false}, numericality: true},
                    "TickSize": {presence: {allowEmpty: false}, numericality: true},
                    "TickValue": {presence: {allowEmpty: false}, numericality: true},
                    "MinLot": {presence: {allowEmpty: false}, numericality: true},
                    "StepLot": {presence: {allowEmpty: false}, numericality: true},
                    "MaxLot": {presence: {allowEmpty: false}, numericality: true},
                    "IsCurrentSessionValid": {presence: {allowEmpty: false}, numericality: true},
                    "Unit": {presence: false},
                    "SwapsLong": {presence: {allowEmpty: false}, numericality: true},
                    "SwapsShort": {presence: {allowEmpty: false}, numericality: true},
                    "TradingTimes": {presence: true, isTradingTimes: true},
                    "id": {presence: {allowEmpty: false}, numericality: true},
                    "Bid": {presence: {allowEmpty: false}, numericality: true},
                    "Ask": {presence: {allowEmpty: false}, numericality: true},
                    "High": {presence: {allowEmpty: false}, numericality: true},
                    "Low": {presence: {allowEmpty: false}, numericality: true},
                    "TickTime": {presence: {allowEmpty: false}, numericality: true},
                    "LastPrice": {presence: {allowEmpty: false}, numericality: true}
                },
                openTrade: {
                    "id": {presence: {allowEmpty: false}, numericality: true},
                    "OrderID": {presence: {allowEmpty: false}, numericality: true},
                    "Cmd": {presence: {allowEmpty: false}, numericality: true},
                    "Comment": {presence: {allowEmpty: true}},
                    "OpenTime": {presence: {allowEmpty: false}, numericality: true},
                    "CloseTime": {presence: {allowEmpty: false}, numericality: true},
                    "OpenPrice": {presence: {allowEmpty: false}, numericality: true},
                    "ClosePrice": {presence: {allowEmpty: false}, numericality: true},
                    "Digits": {
                        presence: {allowEmpty: false},
                        numericality: {greaterThanOrEqualTo: 0, lessThanOrEqualTo: 10}
                    },
                    "Profit": {presence: {allowEmpty: false}, numericality: true},
                    "Commission": {presence: {allowEmpty: false}, numericality: true},
                    "Expiration": {presence: {allowEmpty: false}, numericality: true},
                    "sl": {presence: {allowEmpty: false}, numericality: true},
                    "tp": {presence: {allowEmpty: false}, numericality: true},
                    "Taxes": {presence: {allowEmpty: false}, numericality: true},
                    "Storage": {presence: {allowEmpty: false}, numericality: true},
                    "Volume": {presence: {allowEmpty: false}, numericality: true},
                    "Login": {presence: {allowEmpty: false}, numericality: true},
                    "OutputName": {presence: {allowEmpty: false}},
                    "ContractSize": {presence: {allowEmpty: false}, numericality: true}
                }
            },
            stepChange: {
                20: 5,
                100: 10
            },
            defaultLeverage: 30,
            leverages: [30],
            chartUrl: 'https://nfp.pandats.com/prochart-6.9.2',
            firebase: {},
            googleProviderId: '',
            facebookProviderId: '',
            onesignal: {
                appId: 'cd5e4830-9e56-455b-b863-77050e5b7398',
                safariWebId: 'cd5e4830-9e56-455b-b863-77050e5b7398'
            },
        };

        return localConfig;
    }]);
